module.exports = __webpack_public_path__ + "media/branton-b-animation.5ab65fd8.mp4";